import AOS from 'aos';

export default {
  install: (Vue) => {
    AOS.init({
      offset: 200,
      once: true,
    });

    Vue.mixin({
      updated() {
        this.$nextTick(() => {
          AOS.refreshHard(); // This is needed to avoid the un-animate aos effect
        });
      },
    });
  },
};
